<template>
  <div class="relative inline-block">
    <button
      v-bind="$attrs"
      v-on="$listeners"
      class="relative z-10 button-text flex content-center w-full h-full text-black focus:outline-none"
      :class="{
        'bg-blue-400 hover:bg-blue-500 focus:bg-blue-500': theme === 'blue',
        'bg-orange-400 hover:bg-orange-500 focus:bg-orange-500':
          theme === 'orange',
        'bg-gray-400 hover:bg-blue-400 focus:bg-blue-400': theme === 'gray',
        'bg-white hover:bg-gray-100 focus:bg-gray-100': theme === 'white',
        'text-white bg-red-600 hover:bg-red-700 focus:bg-red-700':
          theme === 'red',
        'bg-gray-300 hover:bg-blue-300 focus:bg-blue-300':
          $attrs.disabled || loading,
        'button-text-loading': loading,
        'px-12 py-4 text-xl': size === 'large',
        'px-4 py-2': size === 'base',
        'px-2 py-1 text-sm': size === 'small',
        uppercase: uppercase,
      }"
    >
      <slot />
    </button>
    <base-loading class="absolute left-0 top-1/2 transform -translate-y-1/2" />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: 'blue',
    },
    size: {
      type: String,
      default: 'base',
    },
    uppercase: Boolean,
    loading: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.button-text {
  transition: color 0.1s, transform 0.4s;
}
.button-text-loading {
  transition: color 0.1s, transform 0.2s;
  transform: translateX(2.5rem);
}
</style>
